import React from 'react';

import Modal from 'react/components/Modal';

import SurveyApplyRulePopup from 'live/views/Survey/Greenmile.Survey.ApplyRulePopup.js';

class ApplicationRulesModal extends React.Component {

    buildModalContent() {
        const { isOpen, closeModalFn, ruleData } = this.props;
        if (isOpen) {

            let ruleDataFromMapToObject = ruleData.toJS();
            const ruleDataIsEmpty = !Object.keys(ruleDataFromMapToObject).length;

            if (ruleDataIsEmpty) {
                ruleDataFromMapToObject = undefined;
            }

            new SurveyApplyRulePopup(ruleDataFromMapToObject)
                .createModalContent(closeModalFn);
        }
    }

    render () {
        const { isOpen, closeModalFn } = this.props;

        return(
            <Modal
                className="application-rules-modal"
                isOpen={isOpen}
                title={Monet.I18n.getResourcesByKey('surveyApplyRules.title')}
                subtitle={Monet.I18n.getResourcesByKey('surveyApplyRules.description')}
                closeModalFn={closeModalFn}
                onAfterOpen={this.buildModalContent.bind(this)}
            />
        )
    }
}

export default ApplicationRulesModal;
